const breedImages = require.context(
  '../../assets/homepage/breeds',
  false,
  /\.(jpeg|jpg|png)$/
);

const breedImageMap = {};
const breederPhotoMap = {};

breedImages
  .keys()
  .filter(key => key.startsWith('./'))
  .forEach(imagePath => {
    const image = breedImages(imagePath);
    const fileName = imagePath
      .replace('./', '')
      .replace(/\.(jpeg|jpg|png)$/, '');

    const breederPhotoMatch = fileName.match(/^(.+)-(\d+)$/);

    if (breederPhotoMatch) {
      // breeder photo: dachshund-1, golden-retriever-2, etc.
      const [, slug, number] = breederPhotoMatch;
      if (!breederPhotoMap[slug]) {
        breederPhotoMap[slug] = {};
      }

      breederPhotoMap[slug][number] = image;
    } else {
      // main breed image: dachshund, golden-retriever, etc.
      breedImageMap[fileName] = image;
    }
  });

function getBreedImage(slug) {
  return breedImageMap[slug] || null;
}

function getBreederPhotos(slug) {
  if (!breederPhotoMap[slug]) {
    return [];
  }

  const photos = [];
  for (let i = 1; i <= 4; i++) {
    const photo = breederPhotoMap[slug][i];
    if (photo) {
      photos.push(photo);
    }
  }

  return photos;
}

// Breeds for each category
const POPULAR_BREEDS = [
  {
    name: 'Dachshund',
    photo_url: getBreedImage('dachshund'),
    slug: 'dachshund',
    breeder_photos: getBreederPhotos('dachshund')
  },
  {
    name: 'Golden Retriever',
    photo_url: getBreedImage('golden-retriever'),
    slug: 'golden-retriever',
    breeder_photos: getBreederPhotos('golden-retriever')
  },
  {
    name: 'Chihuahua',
    photo_url: getBreedImage('chihuahua'),
    slug: 'chihuahua',
    breeder_photos: getBreederPhotos('chihuahua')
  },
  {
    name: 'Labrador Retriever',
    photo_url: getBreedImage('labrador-retriever'),
    slug: 'labrador-retriever',
    breeder_photos: getBreederPhotos('labrador-retriever')
  },
  {
    name: 'Poodle',
    photo_url: getBreedImage('poodle'),
    slug: 'poodle',
    breeder_photos: getBreederPhotos('poodle')
  },
  {
    name: 'Yorkshire Terrier',
    photo_url: getBreedImage('yorkshire-terrier'),
    slug: 'yorkshire-terrier',
    breeder_photos: getBreederPhotos('yorkshire-terrier')
  },
  {
    name: 'German Shepherd',
    photo_url: getBreedImage('german-shepherd-dog'),
    slug: 'german-shepherd-dog',
    breeder_photos: getBreederPhotos('german-shepherd-dog')
  },
  {
    name: 'Goldendoodle',
    photo_url: getBreedImage('goldendoodle'),
    slug: 'goldendoodle',
    breeder_photos: getBreederPhotos('goldendoodle')
  }
];

const LARGE_BREEDS = [
  {
    name: 'Cane Corso',
    photo_url: getBreedImage('cane-corso'),
    slug: 'cane-corso',
    breeder_photos: getBreederPhotos('cane-corso')
  },
  {
    name: 'Doberman Pinscher',
    photo_url: getBreedImage('doberman-pinscher'),
    slug: 'doberman-pinscher',
    breeder_photos: getBreederPhotos('doberman-pinscher')
  },
  {
    name: 'Boxer',
    photo_url: getBreedImage('boxer'),
    slug: 'boxer',
    breeder_photos: getBreederPhotos('boxer')
  },
  {
    name: 'Great Dane',
    photo_url: getBreedImage('great-dane'),
    slug: 'great-dane',
    breeder_photos: getBreederPhotos('great-dane')
  },
  {
    name: 'Bernedoodle',
    photo_url: getBreedImage('bernedoodle'),
    slug: 'bernedoodle',
    breeder_photos: getBreederPhotos('bernedoodle')
  },
  {
    name: 'Rottweiler',
    photo_url: getBreedImage('rottweiler'),
    slug: 'rottweiler',
    breeder_photos: getBreederPhotos('rottweiler')
  },
  {
    name: 'Belgian Malinois',
    photo_url: getBreedImage('belgian-malinois'),
    slug: 'belgian-malinois',
    breeder_photos: getBreederPhotos('belgian-malinois')
  },
  {
    name: 'Siberian Husky',
    photo_url: getBreedImage('siberian-husky'),
    slug: 'siberian-husky',
    breeder_photos: getBreederPhotos('siberian-husky')
  }
];

const ALLERGY_FRIENDLY_BREEDS = [
  {
    name: 'Cavapoo',
    photo_url: getBreedImage('cavapoo'),
    slug: 'cavapoo',
    breeder_photos: getBreederPhotos('cavapoo')
  },
  {
    name: 'Maltipoo',
    photo_url: getBreedImage('maltipoo'),
    slug: 'maltipoo',
    breeder_photos: getBreederPhotos('maltipoo')
  },
  {
    name: 'Miniature Schnauzer',
    photo_url: getBreedImage('miniature-schnauzer'),
    slug: 'miniature-schnauzer',
    breeder_photos: getBreederPhotos('miniature-schnauzer')
  },
  {
    name: 'Portuguese Water Dog',
    photo_url: getBreedImage('portuguese-water-dog'),
    slug: 'portuguese-water-dog',
    breeder_photos: getBreederPhotos('portuguese-water-dog')
  },
  {
    name: 'Bichon Frise',
    photo_url: getBreedImage('bichon-frise'),
    slug: 'bichon-frise',
    breeder_photos: getBreederPhotos('bichon-frise')
  },
  {
    name: 'Havanese',
    photo_url: getBreedImage('havanese'),
    slug: 'havanese',
    breeder_photos: getBreederPhotos('havanese')
  },
  {
    name: 'Poodle',
    photo_url: getBreedImage('poodle'),
    slug: 'poodle',
    breeder_photos: getBreederPhotos('poodle')
  },
  {
    name: 'Goldendoodle',
    photo_url: getBreedImage('goldendoodle'),
    slug: 'goldendoodle',
    breeder_photos: getBreederPhotos('goldendoodle')
  }
];

const SMALL_BREEDS = [
  {
    name: 'Toy Australian Shepherd',
    photo_url: getBreedImage('toy-australian-shepherd'),
    slug: 'toy-australian-shepherd',
    breeder_photos: getBreederPhotos('toy-australian-shepherd')
  },
  {
    name: 'Shih Tzu',
    photo_url: getBreedImage('shih-tzu'),
    slug: 'shih-tzu',
    breeder_photos: getBreederPhotos('shih-tzu')
  },
  {
    name: 'Pomeranian',
    photo_url: getBreedImage('pomeranian'),
    slug: 'pomeranian',
    breeder_photos: getBreederPhotos('pomeranian')
  },
  {
    name: 'Cavalier King Charles Spaniel',
    photo_url: getBreedImage('cavalier-king-charles-spaniel'),
    slug: 'cavalier-king-charles-spaniel',
    breeder_photos: getBreederPhotos('cavalier-king-charles-spaniel')
  },
  {
    name: 'Pembroke Welsh Corgi',
    photo_url: getBreedImage('pembroke-welsh-corgi'),
    slug: 'pembroke-welsh-corgi',
    breeder_photos: getBreederPhotos('pembroke-welsh-corgi')
  },
  {
    name: 'Pug',
    photo_url: getBreedImage('pug'),
    slug: 'pug',
    breeder_photos: getBreederPhotos('pug')
  },
  {
    name: 'Boston Terrier',
    photo_url: getBreedImage('boston-terrier'),
    slug: 'boston-terrier',
    breeder_photos: getBreederPhotos('boston-terrier')
  },
  {
    name: 'Maltese',
    photo_url: getBreedImage('maltese'),
    slug: 'maltese',
    breeder_photos: getBreederPhotos('maltese')
  }
];

const GOOD_WITH_FAMILIES_BREEDS = [
  {
    name: 'Australian Shepherd',
    photo_url: getBreedImage('australian-shepherd'),
    slug: 'australian-shepherd',
    breeder_photos: getBreederPhotos('australian-shepherd')
  },
  {
    name: 'Bulldog',
    photo_url: getBreedImage('bulldog'),
    slug: 'bulldog',
    breeder_photos: getBreederPhotos('bulldog')
  },
  {
    name: 'Basset Hound',
    photo_url: getBreedImage('basset-hound'),
    slug: 'basset-hound',
    breeder_photos: getBreederPhotos('basset-hound')
  },
  {
    name: 'Cocker Spaniel',
    photo_url: getBreedImage('cocker-spaniel'),
    slug: 'cocker-spaniel',
    breeder_photos: getBreederPhotos('cocker-spaniel')
  },
  {
    name: 'French Bulldog',
    photo_url: getBreedImage('french-bulldog'),
    slug: 'french-bulldog',
    breeder_photos: getBreederPhotos('french-bulldog')
  },
  {
    name: 'Border Collie',
    photo_url: getBreedImage('border-collie'),
    slug: 'border-collie',
    breeder_photos: getBreederPhotos('border-collie')
  },
  {
    name: 'Beagle',
    photo_url: getBreedImage('beagle'),
    slug: 'beagle',
    breeder_photos: getBreederPhotos('beagle')
  },
  {
    name: 'Bernese Mountain Dog',
    photo_url: getBreedImage('bernese-mountain-dog'),
    slug: 'bernese-mountain-dog',
    breeder_photos: getBreederPhotos('bernese-mountain-dog')
  }
];

export const BREED_FILTERS = [
  {
    label: 'Popular breeds',
    photo_url: getBreedImage('dachshund'),
    breeds: POPULAR_BREEDS
  },
  {
    label: 'Large breeds',
    photo_url: getBreedImage('bernedoodle'),
    breeds: LARGE_BREEDS
  },
  {
    label: 'Allergy-friendly',
    photo_url: getBreedImage('poodle'),
    breeds: ALLERGY_FRIENDLY_BREEDS
  },
  {
    label: 'Small breeds',
    photo_url: getBreedImage('pembroke-welsh-corgi'),
    breeds: SMALL_BREEDS
  },
  {
    label: 'Good with families',
    photo_url: getBreedImage('australian-shepherd'),
    breeds: GOOD_WITH_FAMILIES_BREEDS
  }
];

export const FUTURE_BREEDER_VIDEOS = [
  {
    breederName: 'Angel A.',
    breedName: 'Miniature Australian Shepherds',
    muxPlaybackId: 'J2sY69Od3p1r4U00mkYH00SNB13NKvyuWip9d3GJcCNc4',
    breederSlug: 'angels-aussies-oklahoma'
  },
  {
    breederName: 'Cassidy P.',
    breedName: 'Bernedoodles',
    muxPlaybackId: 'cI4qgePsBWkgxy2DkOPXhmkad02FLJvim011JeEQBFBjU',
    breederSlug: 'sassy-pants-pups-colorado'
  },
  {
    breederName: 'Melissa J.',
    breedName: 'Aussiedoodles',
    muxPlaybackId: 'sfk5T202KKVheOt6ib22Qtt7hwE5uB01dl4b00GONQohA4',
    breederSlug: 'miami-mini-doodles-florida'
  },
  {
    breederName: 'Mayra O.',
    breedName: 'Shih Tzus',
    muxPlaybackId: 'S7orlhfoaQTXF8HJrwPXJ4AvDbqaiUWLK02WpiYS9tZw',
    breederSlug: 'mayras-shih-tzus-florida'
  },
  {
    breederName: 'Joy D.',
    breedName: 'Miniature Australian Shepherds',
    muxPlaybackId: 'eoWDTf8HqNNasp6icUVUqO2jOCT601ho3zlURVPUahIs',
    breederSlug: 'joyfulpuppies-california'
  },
  {
    breederName: 'Chelsea J.',
    breedName: 'Labrador Retrievers',
    muxPlaybackId: 'ZqmAL6oTXEv301LpV8HE2I202H2qUL3OU45WZab6Q00kMc',
    breederSlug: 'cmj-kennels-texas'
  },
  {
    breederName: 'Katherine G.',
    breedName: 'Yorkshire Terriers',
    muxPlaybackId: '1t1GGWGwpOz302uWAwYkBVtOpTUiE997xWierpDunnz00',
    breederSlug: 'katherines-yorkies-and-poodles-florida'
  },
  {
    breederName: 'Kelly M.',
    breedName: 'Aussiedoodles',
    muxPlaybackId: '9vSeBrlmufzUvF4wGO7uJZUH2i7XzA6BaRNZbpyTI3g',
    breederSlug: 'bluebird-family-farm-new-york'
  },
  {
    breederName: 'Jennifer G.',
    breedName: 'Siberian Huskies',
    muxPlaybackId: 'vfe8W00sF9Cm48nfpAUm8l4ismyqhhIltDC4U9HABluk',
    breederSlug: 'repurposed-paradise-farm-michigan'
  },
  {
    breederName: 'Courtney B.',
    breedName: 'Australian Cattle Dogs',
    muxPlaybackId: 'EX6jTo02r9BP6o401oFoFraRw00KRclHzeC7v02NmGEZGO8',
    breederSlug: 'loveaheeler-oklahoma'
  },
  {
    breederName: 'Amber & Randy J.',
    breedName: 'Doberman Pinschers',
    muxPlaybackId: 'LdxFR96YSI027kocpaNMiAfA7A9aflTki9ZxNMPo02JaU',
    breederSlug: 'jensen-dobermans-and-dachshunds-indiana'
  },
  {
    breederName: 'Kiarra F.',
    breedName: 'Golden Retrievers',
    muxPlaybackId: '7PVev02WqlHJyUK7UXyMRcm8hFetcXIF7oK8JERG7TtI',
    breederSlug: 'kn-golden-retriever-companion-arizona'
  }
];
